export const TABLET_BREAKPOINT = 768;
export const DESKTOP_BREAKPOINT = 1024;

export const CUSTOM_CREATIVE_SIZE = [1, 1];

const FLUID_SIZE = 'fluid';

// Standard banner ad sizes
export const STANDARD_MOBILE_SIZES = [[300, 250], [320, 50], [320, 100]];
export const STANDARD_TABLET_SIZES = [[320, 50], [320, 100], [728, 90]];
export const STANDARD_DESKTOP_SIZES = [[728, 90], [970, 90], [970, 250]];

export const RAIL_SIZES = [[300, 600], [300, 250]];
export const STICKY_SIZES = [[320, 50]];

// Custom sizes for in-house or direct sold campaigns
const CUSTOM_CAMPAIGN_MOBILE_SIZES = [
  /* removed */
];
const CUSTOM_CAMPAIGN_TABLET_SIZES = [
  /* removed */
];
const CUSTOM_CAMPAIGN_DESKTOP_SIZES = [
  /* removed */
];

// Combined sizes
const MOBILE_SIZES = [
  ...STANDARD_MOBILE_SIZES,
  ...CUSTOM_CAMPAIGN_MOBILE_SIZES,
  CUSTOM_CREATIVE_SIZE,
  FLUID_SIZE
];
const TABLET_SIZES = [
  ...STANDARD_TABLET_SIZES,
  ...CUSTOM_CAMPAIGN_TABLET_SIZES,
  CUSTOM_CREATIVE_SIZE,
  FLUID_SIZE
];
const DESKTOP_SIZES = [
  ...STANDARD_DESKTOP_SIZES,
  ...CUSTOM_CAMPAIGN_DESKTOP_SIZES,
  CUSTOM_CREATIVE_SIZE,
  FLUID_SIZE
];

export const DEFAULT_AMP_AD_SIZE = [300, 250];

export const MOBILE_ONLY_AD_SIZE_MAPPING = [
  { viewport: [0, 0], slot: MOBILE_SIZES },
  { viewport: [TABLET_BREAKPOINT, 0], slot: [] }
];

export const TABLET_ONLY_AD_SIZE_MAPPING = [
  {
    viewport: [TABLET_BREAKPOINT, 0],
    slot: TABLET_SIZES
  },
  { viewport: [DESKTOP_BREAKPOINT, 0], slot: [] },
  { viewport: [0, 0], slot: [] }
];

export const TABLET_AND_DESKTOP_AD_SIZE_MAPPING = [
  {
    viewport: [TABLET_BREAKPOINT, 0],
    slot: TABLET_SIZES
  },
  { viewport: [DESKTOP_BREAKPOINT, 0], slot: DESKTOP_SIZES },
  { viewport: [0, 0], slot: [] }
];

export const DESKTOP_ONLY_AD_SIZE_MAPPING = [
  { viewport: [DESKTOP_BREAKPOINT, 0], slot: DESKTOP_SIZES },
  { viewport: [0, 0], slot: [] }
];

export const DEFAULT_AD_SIZE_MAPPING = [
  { viewport: [0, 0], slot: MOBILE_SIZES },
  {
    viewport: [TABLET_BREAKPOINT, 0],
    slot: TABLET_SIZES
  },
  { viewport: [DESKTOP_BREAKPOINT, 0], slot: DESKTOP_SIZES }
];

export const RAIL_AD_SIZE_MAPPING = [
  {
    viewport: [DESKTOP_BREAKPOINT, 0],
    slot: [[300, 250], CUSTOM_CREATIVE_SIZE]
  },
  // Only render a 300x600 if the viewport is tall enough to trigger
  // a viewable event (i.e. 50% of the creative is in view)
  {
    viewport: [DESKTOP_BREAKPOINT, 768],
    slot: [...RAIL_SIZES, CUSTOM_CREATIVE_SIZE]
  },
  { viewport: [0, 0], slot: [] }
];

export const IN_POST_AD_SIZE_MAPPING_MOBILE = [
  { viewport: [0, 0], slot: MOBILE_SIZES },
  { viewport: [DESKTOP_BREAKPOINT, 0], slot: [] }
];

export const IN_POST_AD_SIZE_MAPPING_DESKTOP = [
  // Note: at the desktop breakpoint the post's text column is not wide enough
  // for the "standard" desktop sizes. Instead we must use a narrower ad so it
  // doesn't break out of the column.
  {
    viewport: [DESKTOP_BREAKPOINT, 0],
    slot: [[300, 250], CUSTOM_CREATIVE_SIZE, FLUID_SIZE]
  },
  // When the viewport is 1440 or wider, we can insert a wider desktop ad
  {
    viewport: [1440, 0],
    slot: [[728, 90], CUSTOM_CREATIVE_SIZE, FLUID_SIZE]
  },
  { viewport: [0, 0], slot: [] }
];

export const GALLERY_AD_SIZE_MAPPING = {
  default: [
    { viewport: [0, 0], slot: MOBILE_SIZES },
    {
      viewport: [1440, 0],
      slot: [[728, 90], CUSTOM_CREATIVE_SIZE, FLUID_SIZE]
    }
  ]
};

export const RECIPE_AD_SIZE_MAPPING = [
  { viewport: [0, 0], slot: [CUSTOM_CREATIVE_SIZE, [320, 655]] },
  { viewport: [TABLET_BREAKPOINT, 0], slot: [CUSTOM_CREATIVE_SIZE, [645, 400]] }
];

export const STICKY_AD_SIZE_MAPPING = [
  { viewport: [0, 0], slot: STICKY_SIZES },
  { viewport: [TABLET_BREAKPOINT, 0], slot: [] }
];

export const SPONSORED_PUSHER_SIZE_MAPPING = [
  {
    viewport: [TABLET_BREAKPOINT, 0],
    slot: CUSTOM_CREATIVE_SIZE
  },
  { viewport: [DESKTOP_BREAKPOINT, 0], slot: CUSTOM_CREATIVE_SIZE },
  { viewport: [0, 0], slot: [] }
];
